import { Link } from 'react-router-dom'
import { Button } from '@/components'

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md text-center">
        <p className="text-5xl font-bold text-yayasan-800">404</p>
        <h1 className="mt-3 text-lg font-semibold text-netral-900">Halaman tidak ditemukan</h1>
        <p className="mt-2 text-sm text-netral-500">
          Alamat yang Anda buka tidak tersedia atau sudah dipindahkan. Silakan kembali ke dashboard.
        </p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <Link to="/">
            <Button>Kembali ke Dashboard</Button>
          </Link>
          <Link to="/tagihan">
            <Button varian="garis">Lihat Tagihan</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
